module.exports = __webpack_public_path__ + "pic/66.58c654e7.png";